import { MarketingPageHeader } from '../Header/MarketingPageHeader';
import { Footer } from '../Landing/LandingFooter';
import { DeepLiquiditySection } from './DeepLiquiditySection';
import { LiquiditySourcesHero } from './LiquiditySourcesHero';
import { LiquiditySourcesTable } from './LiquiditySourcesTable';

export function LiquiditySourcesLanding() {
  return (
    <>
      <MarketingPageHeader />
      <LiquiditySourcesHero />
      <main className="mx-4 tablet:mx-11 desktop:mx-auto desktop:px-4 pb-0" data-lock-theme="true">
        <LiquiditySourcesTable />
        <DeepLiquiditySection />
      </main>
      <Footer />
    </>
  );
}
